import { showView } from '../actions/publicActions';
import { onShowFullCompose } from 'owa-calendar-compose-form-store';
import { PopoutChildState, setPopoutChildState } from 'owa-popout-v2';
import { orchestrator } from 'satcheljs';

export default function registerOnShowFullComposeOrchestrator() {
    orchestrator(onShowFullCompose, () => {
        showView('Compose');
        setPopoutChildState(PopoutChildState.Ready);
    });
}
